import { Button } from "antd";
import type React from "react";
import { useDraggableButton } from "../hooks/useDraggableButton";

interface DebugButtonProps {
  onOpen: () => void;
}

export const DebugButton: React.FC<DebugButtonProps> = ({ onOpen }) => {
  const { position, isDragging, buttonRef, handlePointerDown, handlePointerUp } =
    useDraggableButton();

  const handleOpenPanel = () => {
    const isClick = handlePointerUp();
    if (isClick) onOpen();
  };

  return (
    <div
      ref={buttonRef}
      className={`fixed z-[1000] ${isDragging ? "cursor-grabbing" : "cursor-grab"} ${isDragging ? "transition-none" : "transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)]"} touch-none`}
      style={{
        left: position.x,
        top: position.y,
      }}
      onPointerDown={handlePointerDown}
      onPointerUp={handleOpenPanel}
    >
      <Button type="primary" size="small">
        Debug
      </Button>
    </div>
  );
};
